import React from 'react';
import PropTypes from 'prop-types';
import WalmartPlusLogo from './walmart_plus_logo';
import { PRINTS_6X4_PROMOTION_KEY } from './constants';

// Each half of the title is its own span so _wm-plus-promotion.scss can break
// the message after "free" on cards wide enough for it. The space between them
// is explicit so the halves stay separate words when they wrap naturally.
const promotions = {
  [PRINTS_6X4_PROMOTION_KEY]: (
    <>
      <span className="wm-plus-promotion__line">
        Walmart+ members get 25 free
      </span>{' '}
      <span className="wm-plus-promotion__line">
        4x6&Prime; photo prints every month
      </span>
    </>
  ),
};

const shortMessage = (
  <div className="wm-plus-promotion__message wm-plus-promotion__message--short d-flex align-items-center">
    <WalmartPlusLogo />
    <small className="ml-2">Discount applied at checkout.</small>
  </div>
);

const WalmartPlusPromotion = ({ promotionMessageKey, fullMessage }) => {
  const title = promotions[promotionMessageKey];

  if (!title) {
    return null;
  }

  if (!fullMessage) {
    return shortMessage;
  }

  return (
    <div className="wm-plus-promotion__message wm-plus-promotion__message--full card shadow-sm">
      <div className="card-body d-flex align-items-center">
        <div className="flex-shrink-0 mr-3">
          <WalmartPlusLogo primary={false} />
        </div>
        <div className="flex-grow-1 d-flex flex-column">
          <h6 className="font-weight-bolder mb-0 text-primary small">
            {title}
          </h6>
          <small>Discount applied at checkout.</small>
        </div>
        <a
          href="https://www.walmart.com/plus"
          target="_blank"
          rel="noopener noreferrer"
          className="ml-3 text-nowrap small text-dark text-decoration-underline">
          Learn more
        </a>
      </div>
    </div>
  );
};

WalmartPlusPromotion.propTypes = {
  promotionMessageKey: PropTypes.oneOf([PRINTS_6X4_PROMOTION_KEY]),
  fullMessage: PropTypes.bool,
};

export default WalmartPlusPromotion;
